import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Box } from '../../../../../../../../CommonComponents/OPL/Box/Box';
import { InputNumberMask } from '../../../../../../../../CommonComponents/OPL/Input/InputNumberMask';
import { Label } from '../../../../../../../../CommonComponents/OPL/Label/Label';
import { Toggle } from '../../../../../../../../CommonComponents/OPL/Toggle/Toggle';
import { FormFields } from '../../AccountForm.meta';
import { TabWrapper } from '../../AccountForm.styles';
import { Contributions } from '../Contributions/Contributions';
import { Select } from '../../../../../../../../CommonComponents/OPL/Select/Select/Select';
import { useEmployerMatch } from './useEmployerMatch';

interface EmployerMatchProps {
  hasSelfEmployedContribution?: boolean;
  hasNonElectiveContribution?: boolean;
}

export const EmployerMatch = ({
  hasSelfEmployedContribution = false,
  hasNonElectiveContribution = true,
}: EmployerMatchProps) => {
  const formBag = useFormContext<FormFields>();

  const {
    data: {
      employerMatchUnits,
      employerContributionTaxStatusesOptions,
      hasContributionStatus,
      employerMatchUnitsOptions,
    },
  } = useEmployerMatch();

  return (
    <TabWrapper>
      <Contributions />

      <Controller
        control={formBag.control}
        name="bankAccount.EmployerNonElectiveContribution"
        render={({ field }) => (
          <InputNumberMask
            {...field}
            selectorProps={
              !hasNonElectiveContribution
                ? {
                    defaultValue:
                      employerMatchUnitsOptions.find(
                        option => option.value === employerMatchUnits,
                      ) ?? employerMatchUnitsOptions[0],
                    options: employerMatchUnitsOptions,
                    onChange(opt) {
                      formBag.setValue('bankAccount.EmployerMatchUnits', opt.value);
                    },
                    ariaLabel: 'Employer Match Units',
                  }
                : undefined
            }
            rightIcon={hasNonElectiveContribution ? 'far fa-percent' : undefined}
            decimalScale={2}
            allowNegative={false}
            thousandSeparator={false}
            label={
              hasNonElectiveContribution
                ? 'Non-elective Employer Contribution'
                : 'Employer Contribution'
            }
          />
        )}
      />

      {hasContributionStatus && (
        <Controller
          control={formBag.control}
          name="bankAccount.EmployerNonElectiveContributionTaxStatus"
          render={({ field: { value, onChange, ref } }) => (
            <Select
              label="Non-elective Employer Contribution Status"
              innerRef={ref}
              value={employerContributionTaxStatusesOptions.find(option => option.value === value)}
              options={employerContributionTaxStatusesOptions}
              onChange={opt => onChange(opt?.value)}
              isPortal
            />
          )}
        />
      )}

      {hasSelfEmployedContribution && (
        <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
          <Label htmlFor="self-employed-contribution">Self Employed Contribution</Label>
          <Toggle
            {...formBag.register('bankAccount.SelfEmployed')}
            id="self-employed-contribution"
          />
        </Box>
      )}
    </TabWrapper>
  );
};
